import React from 'react';
import {BrowserRouter as Router, Route, Link, Switch} from 'react-router-dom'
import Display from '../helpers/display'
import Loading from '../loading';
import Transact from './transact';
import firebase from 'firebase';
import Notifications, {notify} from 'react-notify-toast';
import _ from 'lodash';

class Profile extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			overlay: null,
			transactions:null
		}
		this.handleUpdate = this.handleUpdate.bind(this);
		this.handleTransact = this.handleTransact.bind(this);
		this.handleTransactCallback = this.handleTransactCallback.bind(this);
	}

	handleTransact(type) {
		this.setState({overlay: type})
	}

	handleTransactCallback(state) {
		if(state === 'close') this.setState({overlay:null});
	}

	handleSetPermission(permission) {
		firebase.database().ref(`profiles/${this.props.game.id}/${this.props.profile.id}`).update({
			permission: permission
		})
		.then(response => {
			notify.show(`${this.props.profile.name} is now a ${permission}`, 'success');
		})
		.catch(error => {
			notify.show(`Could not update the permissions for ${this.props.profile.name}`, 'error');
			console.warn('Error updating permissions', error);
		})
	}

	componentDidMount() {
		this.handleUpdate(this.props)
	}

	componentDidUpdate(newProps) {
		if(this.props === newProps) return;
		this.handleUpdate(newProps)
	}

	handleUpdate(props) {
		this.setState({transactions: _.orderBy(this.props.profile.transactions, 'created' ).reverse()})
	}

	render() {

		if (!this.props.profile) {
			return <Loading text="Loading Profile"/>
		}

		if(this.state.overlay) {
			return <Transact type={this.state.overlay} callback={this.handleTransactCallback} game={this.props.game} profiles={this.props.profiles} from={this.props.user.uid} to={this.props.profile.id}/>
		}

		return <section className="profile-page ridged -bottom">

		<div className="content">

			<div className="profile-header">
				<span className="game">{this.props.game.name}</span>
				<h2>{this.props.profile.name}</h2>
				<div className="profile-image">
					{this.props.profile.photoURL && <span style={{backgroundImage: 'url(' + this.props.profile.photoURL + ')'}}></span>}
					{!this.props.profile.photoURL && <span></span>}
				</div>

				{this.props.profile.permission === 'leader' && <span className="label">Leader</span>}
			</div>

			<section className="profile-content">

			{this.props.profile.permission === 'leader' && <div className="profile-attributes">
				<div className="attribute"><p>{this.props.profile.name} is a leader of this game</p></div>
			</div>}

			{this.props.profile.permission !== 'leader' && <div className="profile-attributes">
				<div className="attribute">
					<div className="level">
						<h5>Wallet</h5>
						<h3><strong>${Display.walletTotal(this.props.profile.transactions)}</strong></h3>
					</div>
					<div className="rank">
						<h5>Rank</h5>
						<h3>
						<strong>{Display.walletRank(this.props.profile.id, this.props.profiles)}</strong> <span>/</span>{Display.totalParticipants(this.props.profiles)}</h3>
					</div>
				</div>

				<div className="attribute">
					<div className="level">
						<h5>Education</h5>
						<h3>{Display.educationName(this.props.profile.education)}</h3>
					</div>
					<div className="rank">
						<h5>Rank</h5>
						<h3>
						<strong>{Display.educationRank(this.props.profile.id, this.props.profiles)}</strong> <span>/</span>{Display.totalParticipants(this.props.profiles)}</h3>
					</div>
				</div>

				<div className="attribute">
					<h5>Transactions</h5>

					{this.state.transactions && <ul className="transactions">
					{Object.keys(this.state.transactions).map(id =>
						<li key={id}>
							<p className="fineprint">
								<strong>
									<span className="default-text">$</span>
									{this.state.transactions[id].amount < 0 && <span className="minus">-</span>}
									<span>{Math.abs(this.state.transactions[id].amount)}</span>
								</strong>
								<span className="default-text">{this.state.transactions[id].description}</span>
							</p>
						</li>
					)}
					</ul>}
				</div>
			</div>}


		{
			// Actions can't be taken on your own profile
			this.props.userProfile !== this.props.profile &&
			<div className="profile-actions">
				<h5>Actions</h5>

				{/* Actions for participants */}
				{this.props.profile.permission === 'participant' && <div>

					{/* Anyone can send money */}
					<a className="button -primary -huge" onClick={() => this.handleTransact('send')}>Send Money</a>

					{/* Only leaders can take money */}
					{this.props.userProfile.permission === 'leader' &&
					<a className="button -primary -huge" onClick={() => this.handleTransact('take')}>Take Money</a>}

					{/* Only leaders can update education */}
					{this.props.userProfile.permission === 'leader' &&
					<a className="button -secondary -huge" onClick={() => this.handleTransact('educate')}>Update Education</a>}

					{/* Leaders can't demote themselves */}
					{this.props.userProfile.permission === 'leader' && this.props.profile.permission !== 'leader' && <a className="button -secondary -huge -outline" onClick={() => this.handleSetPermission('leader')}>Make Leader</a>}

				</div>}

				{/* Actions for leaders */}
				{this.props.profile.permission === 'leader' && <div>

					{this.props.userProfile.permission === 'leader' && this.props.profile.permission === 'leader' && <a className="button -secondary -huge -outline" onClick={() => this.handleSetPermission('participant')}>Make Participant</a>}

				</div>}

			</div>
		}
		</section>

		</div>
		</section>
	}
}

export default Profile



// WEBPACK FOOTER //
// ./src/components/game/profile.js